module.exports = __webpack_public_path__ + "img/weibo.437a5cd9.png";